<template>
  <!-- 业绩统计 -->
  <div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="业绩概览"
        name="overview"
      >
        <Overview :overview-data="overviewData" />
      </el-tab-pane>
      <el-tab-pane
        label="导购业绩"
        name="salesperson"
      />
      <el-tab-pane
        label="门店业绩"
        name="store"
      />
      <!-- <el-tab-pane
        label="社群业绩"
        name="community"
      /> -->
    </el-tabs>
    <SpCardContent v-if="activeName !== 'overview'">
      <div class="top-tips">
        <!-- 列表的搜索和操作 -->
        <div class="top-search">
          <el-date-picker
            v-model="params.date"
            class="year"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月"
            :picker-options="pickerOptions"
          />
          <template v-if="activeName === 'salesperson'">
            <el-input
              v-model="keyword"
              class="name-mobile-input"
              placeholder="请输入内容"
            >
              <el-select
                slot="prepend"
                v-model="keywordType"
                style="width: 120px"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="(item, index) in keyWordMap"
                  :key="index"
                  :label="item"
                  :value="index"
                />
              </el-select>
            </el-input>
          </template>
          <template v-if="activeName === 'community'">
            <el-input
              v-model="salesperson_info"
              placeholder="群管理员昵称"
              class="input-m m-r-6"
              clearable
            />
          </template>

          <el-button
            v-if="activeName !== 'community'"
            size="small"
            @click="storeVisible = true"
          >
            <span v-if="selectStoreData.length > 0">已选择 {{ selectStoreData.length }}家门店</span>
            <span v-else>添加门店以筛选</span>
          </el-button>
          <el-button
            v-else
            size="small"
            @click="communityVisible = true"
          >
            <span
              v-if="selectCommunityData.length > 0"
            >已选择 {{ selectCommunityData.length }}个社群</span>
            <span v-else>添加社群以筛选</span>
          </el-button>

          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getList()"
          >
            搜索
          </el-button>
          <el-button
            type="primary"
            @click="handleExport"
          >
            导出{{ activeNameText }}业绩
          </el-button>
        </div>
      </div>

      <!-- 列表展示 -->
      <el-table
        v-loading="loading"
        :data="list"
      >
        <!-- 循环列表 -->
        <el-table-column
          v-for="item in menuList"
          :key="item.name"
          :prop="item.name"
          :label="item.label"
        />
        <el-table-column
          prop="prop"
          label="业绩"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.performance_detail"
              :key="index"
            >
              <div v-if="item.total_fee > 0">
                {{ item.title }}: <span class="money-icon">￥</span>{{ item.total_fee / 100 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_performance"
          label="业绩合计"
        >
          <template slot-scope="scope">
            <div><span class="money-icon">￥</span>{{ scope.row.total_performance / 100 }}</div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
        class="content-padded content-right"
        style="margin-top: 16px"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <!-- 明细对话框 -->
      <detail-dialog
        :active-name="activeName"
        :dialog-visible="dialogVisible"
        :dialog-date="dialogDate"
        :dialog-data="dialogData"
        @closeDetailDialog="closeDetailDialog"
      />

      <!-- 导出报表对话框 -->
      <SpExportList
        v-model="exportDialogVisible"
        :show-store-select="true"
        :files-type="fileType"
        :show-employee-status="activeName === 'salesperson'"
        :show-sales-person-status="showSalesPersonStatus"
        :show-store-status="showStoreStatus"
      />

      <!-- 编辑门店对话框 -->
      <SpStoreSelect
        v-model="storeVisible"
        :select-data="selectStoreData"
        @chooseStore="chooseStore"
      />

      <!-- 选择社群 -->
      <SpCommunitySelect
        v-model="communityVisible"
        :select-data="selectCommunityData"
        @chooseCommunity="chooseCommunity"
      />
    </SpCardContent>
  </div>
</template>

<script>
import detailDialog from '../components/detailDialog'
import Overview from './comps/overviewProfitlist'

import { GuideMenuList, communityMenuList, storeMenuList } from '../untils/menulist'

export default {
  name: 'Profitlist',
  components: {
    detailDialog,
    Overview
  },
  data () {
    const keyWordMap = {
      'employee_numbers': '员工工号',
      'employee_name': '员工姓名'
    }
    return {
      keyWordMap,
      keywordType: 'employee_numbers',
      keyword: '',
      pickerOptions: {
        disabledDate (date) {
          return date.getTime() > Date.now()
        }
      },
      loading: false, //列表的加载
      activeName: 'overview', //当前tab选中
      activeNameText: '业绩概览', //选中的tab的名称
      list: [], //列表数据
      total_count: 0, //总数据量
      params: {
        page: 1,
        page_size: 20,
        date:
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1 < 10
            ? '0' + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1),
        store_id: '',
        chat_ids: ''
      },
      salesperson_info: '', //导购员名字或手机号
      dialogDate: '', //明细的日期
      dialogVisible: false, //明细对话框显示与否
      dialogData: {}, //明细对话框数据
      exportDialogVisible: false, //导出对话框展示与否
      storeVisible: false, //选择门店展示
      selectStoreData: [], //选择门店数据
      communityVisible: false, //选择社群展示
      selectCommunityData: [], //选择社群数据
      overviewData: {},
      menuList: GuideMenuList, // 表头
      fileType: 12, //销售业绩导出 files_type 参数，12：导购业绩， 6：门店业绩,
      showSalesPersonStatus:false,
      showStoreStatus:false
    }
  },
  mounted () {
    const { fromHome } = this.$router.currentRoute.query
    if (fromHome === 'community') {
      this.activeName = 'community'
      this.activeNameText = '社群'
      this.params.store_id = ''
    }
    // this.getList()
    this.getOverview()
  },
  methods: {
    // 获取业绩列表数据
    async getList () {
      this.loading = true
      const params = { ...this.params }
      if (this.activeName === 'salesperson') {
        const { keywordType, keyword } = this
        if (this.activeName === 'salesperson') {
          params[keywordType] = keyword
        }
        // 获取导购业绩列表数据
        const data = await this.$api.performance.getGuideStatistic(params).catch(() => {
          this.loading = false
        })

        if (data) {
          data.list.forEach((v) => {
            v.employee_status_str = v.employee_status === 2 ? '编外' : '员工'
          })
          this.list = data.list
          this.total_count = data.total_count
          this.loading = false
          this.dialogDate = this.params.date
        }
      } else if (this.activeName === 'store') {
        // 获取导购业绩列表数据
        const data = await this.$api.performance.getStoreStatistic(params).catch(() => {
          this.loading = false
        })
        if (data) {
          this.list = data.list
          this.total_count = data.total_count
          this.loading = false
          this.dialogDate = this.params.date
        }
      } else {
        // 获取社群业绩列表数据
        params.salesperson_info = this.salesperson_info
        const data = await this.$api.performance.getCommunityPerformanceList(params).catch(() => {
          this.loading = false
        })
        if (data) {
          this.list = data.list
          this.total_count = data.total_count
          this.loading = false
          this.dialogDate = this.params.date
        }
      }
    },

    // 点击切换tab
    handleClick (tab, event) {
      this.activeName = tab.name
      if (tab.name === 'overview') {
        this.activeNameText = '业绩概览'
        this.getOverview()
      } else if (tab.name === 'salesperson') {
        this.activeNameText = '导购'
        this.menuList = GuideMenuList
        this.fileType = 12,
        this.showStoreStatus = false
        this.showSalesPersonStatus = true
        this.initList()
      } else if (tab.name === 'store') {
        this.activeNameText = '门店'
        this.menuList = storeMenuList
        this.fileType = 6
        this.showSalesPersonStatus = false
        this.showStoreStatus = true
        console.log(this.showStoreStatus)
        this.initList()
      } else {
        this.activeNameText = '社群'
        this.menuList = communityMenuList
        this.initList()
      }
    },

    initList () {
      this.params.date =
        new Date().getFullYear() +
        '-' +
        (new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1)
      this.params.store_id = ''
      this.params.chat_ids = ''
      this.keywordType = 'employee_numbers'
      this.keyword = ''
      this.selectStoreData = []

      this.params.page = 1
      this.getList()
    },

    // 操作-明细
    handleListClick (row) {
      this.dialogVisible = true
      this.dialogData = row
    },

    // 关闭明细对话框
    closeDetailDialog () {
      this.dialogVisible = false
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 选择店铺数据
    chooseStore (selectdata, storeids) {
      if (selectdata.length > 0) {
        this.selectStoreData = selectdata
        this.params.store_id = storeids
      } else {
        this.selectStoreData = []
        this.params.store_id = 0
      }
      this.storeVisible = false
    },

    // 导出报表
    handleExport () {
      this.exportDialogVisible = true
    },
    closeExportDialog () {
      this.exportDialogVisible = false
    },

    // 选择社群数据
    chooseCommunity (selectdata, ids) {
      if (selectdata.length > 0) {
        this.selectCommunityData = selectdata
        this.params.chat_ids = ids
      } else {
        this.selectCommunityData = []
        this.params.chat_ids = 0
      }
      this.communityVisible = false
    },

    // 获取业绩概览数据
    async getOverview () {
      const data = await this.$api.performance.getOverviewStatistic()
      if (data) {
        this.overviewData = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-tips {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-left {
    display: flex;
    .left-item {
      margin-right: 30px;
    }
  }
  .top-search {
    display: flex;
    .year {
      min-width: 200px;
    }
    > div {
      margin-right: 6px;
    }
  }
}
.count {
  font-size: 26px;
  padding-right: 5px;
}

.exportbtn {
  margin-bottom: 16px;
}
.guide-name {
  display: flex;
  align-items: center;
  .guide-pic {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 6px;
  }
  .guide-icon {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .iconfont {
      font-size: 34px;
      color: #ccc;
      margin-right: 6px;
    }
  }
  .salesperson_name {
    padding-left: 40px;
  }
}
.money-icon {
  font-size: 10px;
}
</style>
